import React, { useState } from 'react';
import styled from 'styled-components';

interface SearchBarProps {
  placeholder?: string;
  onSearch: (query: string) => void;
}

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 16px;
`;

const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  background-color: #1E1B2E;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 0 40px 0 16px;
  color: #fff;
  font-size: 14px;
  outline: none;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
    text-transform: lowercase;
  }
  
  &:focus {
    border-color: rgba(255, 255, 255, 0.2);
  }
`;

const SearchIconContainer = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SearchBar: React.FC<SearchBarProps> = ({ placeholder = 'Search...', onSearch }) => {
  const [query, setQuery] = useState('');
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value);
  };
  
  return (
    <SearchContainer>
      <SearchInput
        type="text"
        placeholder={placeholder}
        value={query}
        onChange={handleChange}
      />
      <SearchIconContainer>
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </SearchIconContainer>
    </SearchContainer>
  );
};

export default SearchBar;
